import React, { useState } from 'react';

import CloseIcon from "../../assets/images/close.png";



const AdminOverlay = ({ mode, closePopup, user, doit, error_message, resetAdminErrorFN, created, departments }) => {

    const [firstname, setFirstname] = useState(user ? user.first_name : "");
    const [lastname, setLastname] = useState(user ? user.last_name : "");
    const [email, setEmail] = useState(user ? user.email : "");
    const [password, setPassword] = useState("");
    const [repeatpassword, setRepeatPassword] = useState("");
    const [role, setRole] = useState(user ? user.role.toLowerCase() : "");
    const [status, setStatus] = useState(user ? user.status.toLowerCase() : "");
    const [department, setDepartment] = useState(user ? user.department_id : "");

    const handleSubmit = (e) => {
        resetAdminErrorFN();
        e.preventDefault();
        doit(mode === "create" ? { first_name: firstname, last_name: lastname, email, password, repeatpassword, role, status, department_id: department } : { user_id: user.user_id, first_name: firstname, last_name: lastname, email, role, status, department_id: department });
    }

    if (created) {
        closePopup();
    }


    return (
        <div className="p-6 bg-white rounded-lg pb-2">
            {/* Title and Definition */}
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-1xl font-semibold text-[#3b3b3b]">Create New User</h1>
                <img src={CloseIcon} alt="Close" className="w-8 h-8 cursor-pointer" onClick={() => closePopup()} />
            </div>
            <div className="mb-6">

                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="First Name"
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        required
                    />

                    <input
                        type="text"
                        placeholder="Last Name"
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        required
                    />


                    <input
                        type="text"
                        placeholder="Email address"
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />




                    {mode === "create" && <input
                        type="text"
                        placeholder="Password"
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />}

                    {mode === "create" && <input
                        type="text"
                        placeholder="Repeat Password"
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={repeatpassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        required
                    />}

                    <select
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        required
                    >
                        <option value="">Select Role</option>
                        <option value="admin">Admin</option>
                        <option value="auditor">Auditor</option>
                        <option value="user">User</option>
                    </select>


                    <select
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        required
                    >
                        <option value="">Select Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>

                    {role === "user" && <select
                        className="w-full p-3 border border-gray-300 rounded mb-4 bg-[#EEF0ED] text-black"
                        value={department}
                        onChange={(e) => setDepartment(e.target.value)}
                        required
                    >
                        <option value="">Select Department</option>
                        {departments && departments.map(department => (
                            <option key={department.department_id} value={department.department_id}>{department.name}</option>
                        ))}
                    </select>
                    }


                    <button
                        className="pt-2 pb-2 text-l font-bold bg-[#3b3b3b] text-white transition duration-200 rounded-[5px] p-5 mt-4 hover:bg-opacity-70"
                        type="submit"
                    >
                        {mode === "create" ? "Create New User" : "Update User"}
                    </button>
                </form>
                {error_message && <p className="p-2 text-red-500">{error_message}</p>}
            </div>

        </div>
    );
};

export default AdminOverlay;
